module.exports = __webpack_public_path__ + "static/media/no-image.7391bc8a.png";